import axios from 'axios';

export async function searchClasses(search, limit, offset = 1, filter = []) {
  const url = `${process.env.REACT_APP_MEILISEARCH_URL}/indexes/classes/search`;
  return axios({
    method: 'POST',
    url,
    data: {
      q: search,
      limit,
      offset,
      filter
    },
    headers: {
      Authorization: `Bearer ${process.env.REACT_APP_MEILISEARCH_TOKEN}`
    }
  });
}
